import React from "react";
import { Link } from "react-router-dom";
import { Trophy } from "lucide-react";

export function Footer() {
  const links = [
    { to: "/how-it-works", label: "How it works" },
    { to: "/rules", label: "Rules" },
    { to: "/terms", label: "Terms" },
    { to: "/privacy", label: "Privacy Policy" },
    { to: "/contact", label: "Contact" },
  ];
  return (
    <footer className="relative z-10 border-t border-white/10 mt-10" data-testid="site-footer">
      <div className="max-w-6xl mx-auto px-4 py-10 flex flex-col sm:flex-row items-center justify-between gap-6">
        <Link to="/" className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-blue-500 to-violet-600 flex items-center justify-center">
            <Trophy className="w-4 h-4 text-white" />
          </div>
          <span className="font-display font-black tracking-tighter">PodiumOne</span>
        </Link>
        <nav className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
          {links.map((l) => (
            <Link key={l.to} to={l.to} data-testid={`footer-link-${l.to.slice(1)}`} className="text-sm text-white/50 hover:text-white transition-colors">
              {l.label}
            </Link>
          ))}
          <a href="mailto:admin@podiumone.to" className="text-sm text-white/50 hover:text-white transition-colors">admin@podiumone.to</a>
        </nav>
      </div>
      <div className="max-w-6xl mx-auto px-4 pb-8 text-xs text-white/30">© {new Date().getFullYear()} PodiumOne · podiumone.to · Real-time pay-to-rank leaderboards.</div>
    </footer>
  );
}
